import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { textCapitalize } from "../../Helpers/Utils";

const TaskCancelModal = ({ taskId, onClose, onSaved }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [reason, setReason] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async () => {
        setSaving(true);
        const response = await Handler({ method: "patch", url: `/admin/task/cancel/${taskId}`, data: { ...(reason.trim() ? { reason: reason.trim() } : {}) } });
        if (response?.success) {
            toast.success(response?.data?.message || "Task cancelled");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to cancel this task"));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">Cancel Task</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <label className="form-label">Reason (optional)</label>
                        <textarea className="form-control" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why is this task being cancelled?" />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" disabled={saving}>Back</button>
                        <button type="button" className="btn btn-danger" onClick={onSubmit} disabled={saving}>
                            {saving ? "Cancelling..." : "Cancel task"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskCancelModal;
